module.exports = __webpack_public_path__ + "static/moderation-rules-e31b37d2addf1a7df71df3cd697b73f7.png";